import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { numberFormatterLocale, onCheckRequireInRowWithdraw } from '../fnTickit';
import { SelectItem } from 'components/Input/Select/SelectItem';
import DialogRemark from '../components/DialogRemark';
import { useMemo, useState } from 'react';
import { BtnRemark } from 'components/Button/ButtonAll';
import { useFieldArray } from 'react-hook-form';
import { FnAxios, FnDialog } from 'utilities/utilities';
import _ from "lodash";

const TableWithdraw = ({ form, objMuseum, isEdit }) => {

    //#region Hook
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    // #endregion

    const [isOpenRemark, setIsOpenRemark] = useState(false)
    const [rowClick, setRowClick] = useState(null)
    const [indexClick, setIndexClick] = useState(0)

    const { control, setValue, watch, clearErrors, reset } = form;

    const { fields } = useFieldArray({
        control,
        name: "lstTicket"
    });
    const watchFieldArray = watch("lstTicket");
    const controlledFields = useMemo(()=>{
        
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });

    },[fields, watchFieldArray])

    const handleOnchange = async (eValue, index, sInput) => {
        let isClear = !(watchFieldArray[index].nStartBook && watchFieldArray[index].nEndBook)
        if (!isClear) {
            await calculateTicketBook(index);
        } else if (isClear) {

            watchFieldArray[index].isRequire = false;
            watchFieldArray[index].nStartTicket = null;
            watchFieldArray[index].nEndTicket = null;
            watchFieldArray[index].nStartTicketID = null;
            watchFieldArray[index].sStartTicketNo = null;
            watchFieldArray[index].nEndTicketID = null;
            watchFieldArray[index].sEndTicketNo = null;

            watchFieldArray[index].nTotalBook = null;
            watchFieldArray[index].nTotalTicket = null;
            watchFieldArray[index].lstOptionBookStart = watchFieldArray[index].lstOptionBook;
            watchFieldArray[index].lstOptionBookEnd = watchFieldArray[index].lstOptionBook;
        }

        let isCheckRequire = onCheckRequireInRowWithdraw(watchFieldArray[index]);
        if (!isCheckRequire) {
            clearErrors(`lstTicket.${index}`)
        }
        setValue(`lstTicket.${index}.isRequire`, isCheckRequire);

        if (watchFieldArray[index].nStartBook) {
            let lstFilter = _.filter(watchFieldArray[index].lstOptionBook, function (o) { return o.value >= watchFieldArray[index].nStartBook });
            watchFieldArray[index].lstOptionBookEnd = lstFilter;
        }

        if (watchFieldArray[index].nEndBook) {
            let lstFilter = _.filter(watchFieldArray[index].lstOptionBook, function (o) { return o.value <= watchFieldArray[index].nEndBook });
            watchFieldArray[index].lstOptionBookStart = lstFilter;
        }
        
        reset({
            ...watch(),
        });
    }

    const calculateTicketBook = async (index) => {
        let param = {
            nTicketTypeID: watchFieldArray[index].nTicketTypeID,
            nMuseum: objMuseum.nMuseumID,
            nStartBookID: watchFieldArray[index].nStartBook,
            nEndBookID: watchFieldArray[index].nEndBook,
        }
        //    DialogFn.BlockUI();
        await AxiosFn.Get(`Ticket/GetCalculateTicketBook`, param, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            //set value in list
            watchFieldArray[index].nStartTicket = objResult.nTicketMin;
            watchFieldArray[index].nEndTicket = objResult.nTicketMax;
            watchFieldArray[index].nStartTicketID = objResult.nTicketMinId;
            watchFieldArray[index].sStartTicketNo = objResult.sTicketMinNo;
            watchFieldArray[index].nEndTicketID = objResult.nTicketMaxId;
            watchFieldArray[index].sEndTicketNo = objResult.sTicketMaxNo;

            watchFieldArray[index].nTotalBook = objResult.nTotalBook;
            watchFieldArray[index].nTotalTicket = objResult.nTotalTicket;
            // reset({
            //     ...watch(),
            // });
        });
    }

    return (
        <>
            <TableContainer id='table-receive' component={Paper}>
                <Table sx={{ minWidth: 1000 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '40px', width: '40px' }}>ที่</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '200px', width: '200px' }}>ประเภทบัตรเข้าชมพิพิธภัณฑ์</TableCell>
                            <TableCell component="th" padding='none' colSpan={2}>เล่มที่</TableCell>
                            <TableCell component="th" padding='none' colSpan={2}>เลขที่</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '70px', width: '70px' }}>จำนวน<br />เล่ม</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '70px', width: '70px' }}>จำนวน<br />ใบ</TableCell>
                            <TableCell component="th" padding='none' rowSpan={2} style={{ minWidth: '70px', width: '70px' }}>หมายเหตุ</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '130px', width: '130px' }}>เริ่มต้น<span className='red'>*</span></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '130px', width: '130px' }}>สิ้นสุด<span className='red'>*</span></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '130px', width: '130px' }}>เริ่มต้น<span className='red'>*</span></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '130px', width: '130px' }}>สิ้นสุด<span className='red'>*</span></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {
                            controlledFields.map((row, index) => {
                                const fieldName = `lstTicket.${index}`;
                                const RowRequire = row.isRequire;

                                return (
                                    <TableRow key={`${fieldName}.sID`}>
                                        <TableCell align="center" >{index + 1}</TableCell>
                                        <TableCell align="left">{row.sTypeTicket}</TableCell>
                                        <TableCell align="right">
                                            <SelectItem
                                                id={`${fieldName}.nStartBook`}
                                                name={`${fieldName}.nStartBook`}
                                                defaultValue={row.nStartBook}
                                                required={RowRequire}
                                                options={row.lstOptionBookStart}
                                                disabled={row.lstOptionBook.length === 0 || isEdit}
                                                onChange={(e) => handleOnchange(e, index, "nStartBook")}
                                                IsShowMessageError={false}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <SelectItem
                                                id={`${fieldName}.nEndBook`}
                                                name={`${fieldName}.nEndBook`}
                                                defaultValue={row.nEndBook}
                                                required={RowRequire}
                                                options={row.lstOptionBookEnd}
                                                disabled={row.lstOptionBook.length === 0 || isEdit}
                                                onChange={(e) => handleOnchange(e, index, "nEndBook")}
                                                IsShowMessageError={false}
                                            />
                                        </TableCell>
                                        <TableCell align="right">{row.sStartTicketNo}</TableCell>
                                        <TableCell align="right">{row.sEndTicketNo}</TableCell>
                                        <TableCell align="right">{numberFormatterLocale(row.nTotalBook, 0)}</TableCell>
                                        <TableCell align="right">{numberFormatterLocale(row.nTotalTicket, 0)}</TableCell>
                                        <TableCell align="center">
                                            {
                                                ((isEdit && row.sRemark) || (!isEdit && row.lstOptionBookStart.length !== 0))
                                                    ?
                                                    <BtnRemark
                                                        id={"btn" + index}
                                                        IsCircleWithOutText
                                                        className='btnicon-remark'
                                                        onClick={() => {
                                                            setRowClick(row)
                                                            setIndexClick(index)
                                                            setIsOpenRemark(true)
                                                        }}
                                                    />
                                                    : null
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                        {
                            controlledFields.length === 0 ?
                                <TableRow >
                                    <TableCell align="center" colSpan={9}>ไม่พบข้อมูล</TableCell>
                                </TableRow>
                                :
                                null
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <DialogRemark
                isOpenRemark={isOpenRemark}
                setIsOpenRemark={setIsOpenRemark}
                row={rowClick}
                controlledFields={controlledFields}
                indexClick={indexClick}
                setValue={setValue}
                isView={isEdit}
            />
        </>
    )
}

export default TableWithdraw
